import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import store from '../../../store/store';
import { filter } from "lodash";
import { ExportRelatController } from './ExportRelatController';
import { TiposSolicitacao } from "./SolicitacaoController";
import ExpectedError from "@tekvue/assets/utils/ExpectedError";

class RelatorioController {
  public static async getVinculoTodos(
    dtMesCompetencia?: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getVinculoTodos';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTiposHierarquia(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const route = 'getTiposHierarquia';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposHierarquia: any[] = response.data.dataset.data;

      return tiposHierarquia;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os tipos de hierarquia!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTiposIncidencia(
    showLoading = true,
  ) {
    const route = 'getTiposIncidencia';

    const params = {
      requestType: 'FilterData',
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const data: any[] = response.data.dataset.data;

      return data;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os tipos de incidência!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getGestorCanViewReport(
    showLoading = true,
  ): Promise<boolean> {
    const nrOrg: string = store.getters.user.nrorg;
    const route = 'getGestorCanViewReport';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const canView: boolean = response.data.dataset.data.canView;

      return canView;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar as configurações de visualização de relatório!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async downloadReport(
    reportLink: string,
  ) {
    const route = 'downloadReport';
    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        link: reportLink,
      },
    };

    const response = await HttpRequest.post(route, params, false);
    const file =  response.data.dataset.data;

    return file;
  }

  public static async getEstruturasSuperioresOperador(
    showLoading = true,
  ) {
    const route = 'getEstruturasSuperioresOperador';

    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDOPERADOR: cdOperador,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas superiores!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoHierarquiaByTipoEstrutura(
    nrTipoEstrutura: string,
    showLoading = true,
  ) {
    const route = 'getTipoHierarquiaByTipoEstrutura';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRTIPOESTRUTURA: nrTipoEstrutura,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const estruturas: any[] = response.data.dataset.data;

      return estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas superiores!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generateSolicitacaoEspelhoReport(
    reportType: string,
    filters: any[],
    nrTipoSolicitacao,
    showLoading = true,
  ) {
    const route = 'generateSolicitacaoEspelhoReport';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      REPORT_TYPE: reportType,
      FILTERS: JSON.stringify(filters),
      NRTIPOSOLICITACAO: nrTipoSolicitacao
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const file: {
        fileName: string;
        base64: string;
        type: string;
      } = response.data.dataset.data;

      if (!file.fileName || !file.base64 || !file.type) {
        throw new Error('Arquivo recebido inválido ou incompleto.');
      }

      return file;
    } catch (err) {
      const message = err as any;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getColumnsSolicitacaoReport(
    nrTipoSolicitacao: TiposSolicitacao,
    showLoading = true,
  ) {
    const route = 'getColumnsSolicitacaoReport';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRTIPOSOLICITACAO: nrTipoSolicitacao,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const data: any = response.data.dataset.data;

      if(!data || (Array.isArray(data) && !data.length)) {
        throw new Error();
      }

      return {
        name: data.name,
        columns: data.columns,
        columnsMapping: data.columnsMapping,
      };

    } catch (err) {
      const message = 'Não foi possível carregar o layout para a exportação desta solicitação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async exportData(
    data: any,
    type: string,
    name: string,
    columns: any[],
  ): Promise<boolean>  {
    try {

      await ExportRelatController.exportData(data, type, name, columns, null);

      return true;
    } catch (err) {
      const e = err as any;
      const message = e.message;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generateReport(
    row: any,
  ): Promise<string> {
    const route = 'generateBirtReport';
    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      ...row,
    };

    try {
      const response = await HttpRequest.get(route, params, false);
      const link: string = response.data.dataset.data.link;

      return link;
    } catch (err) {
      const message = (err as any).response ? ((err as any).response.data.error) : 'Não foi possível gerar o relatório!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export default RelatorioController;